'use client';

import { ContentLoadingView } from '@northladder/design-system';
import { useTranslations } from '@northladder/i18n';

/**
 * -----------------------------------------------------------------------------
 * This is rendered while the app is evaluating the session id from the BE.
 * This ID is retrieved from the URL, and is used to validate the session.
 */
export function ValidatingSessionLoader() {
  const t = useTranslations('ValidatingSessionLoader');

  return <ContentLoadingView subTitle={t('subTitle')} title={t('title')} />;
}
